import { VersionConfig } from '@app/core/services/version-config';
import { createAction, props } from '@ngrx/store';

export const fetchConfig = createAction('[Config] Fetch Config');

export const setConfig = createAction(
  '[Config] Set Config',
  props<{ config: VersionConfig }>(),
);
